import React, {useEffect, useState} from 'react';
import useAuth from "../../hooks/useAuth";
import {Card, CardContent} from "@mui/material";
import {Chart} from "../../components/chart";
import {decode as base64_decode} from "base-64";
import {useSearchParams} from "react-router-dom";
import ApexChart from "react-apexcharts";
import {fillDataNames} from "../../utils/graphUtil";


function Index() {

    const {
        sumUpDays,
        categories,
        staffs,
        paymentModes,
        locations,
        products,
        optionLists,
        weatherDays,
        filter,
    } = useAuth();

    const [searchParams] = useSearchParams();
    const codeBase64 = searchParams.get("codeBase64");
    const [chartOptions, setChartOptions] = useState(null)
    const [sumUpDaysStructured, setSumUpDaysStructured] = useState(null);

    function getAllProducts(sumdays) {
        if (!sumdays || sumdays.length === 0) {
            return [];
        }
        let allProducts = [];
        sumdays.forEach((sumday) => {

            const staffDetails = sumday.detailbyStaff;

            for (const staff in staffDetails) {
                const locations = staffDetails[staff].locations;

                for (const location in locations) {
                    const products = locations[location].products;
                    const timeSlots = products.timeSlot;
                    Object.keys(timeSlots).forEach((timeSlot) => {
                        const timeSlotDetail = timeSlots[timeSlot];

                        Object.keys(timeSlotDetail).forEach((productKey) => {
                            let timeSlotDetailElement = timeSlotDetail[productKey];


                            if (timeSlotDetailElement && typeof timeSlotDetailElement === 'object') {
                                allProducts.push({
                                    name: productKey,
                                    ...timeSlotDetailElement
                                })
                            }
                        })
                    })
                }
            }
        });
        return allProducts;

    }


    useEffect(() => {
        if (!sumUpDays || sumUpDays.length === 0) {
            return;
        }
        if (!products || !staffs || !paymentModes || !locations || !categories) {
            return;
        }

        const structuredSumup = fillNamesOfSumDays(sumUpDays, staffs, locations,
            products, optionLists, paymentModes, categories);
        setSumUpDaysStructured(structuredSumup);

    }, [sumUpDays, products, staffs, paymentModes, locations, categories, optionLists])

    const decoded = base64_decode(codeBase64);
    // eval(decoded);
    // let chartOptions = { series: [], options: {} };

    // function getApexChartData(sumdays, weatherDays) {
    //     // Extraction des données pour le graphique à barres
    //     const categoriesData = {};
    //     const categories = new Set();
    //
    //     sumdays.forEach(day => {
    //         Object.keys(day.detailbyStaff).forEach(staff => {
    //             Object.keys(day.detailbyStaff[staff].locations).forEach(location => {
    //                 const products = day.detailbyStaff[staff].locations[location].products;
    //                 Object.keys(products).forEach(timeSlot => {
    //                     Object.keys(products[timeSlot]).forEach(product => {
    //                         const productData = products[timeSlot][product];
    //                         const categoryName = productData.categoryName || 'Autres';
    //
    //                         // Initialisation des données pour chaque jour
    //                         if (!categoriesData[day.date]) {
    //                             categoriesData[day.date] = {};
    //                         }
    //
    //                         // Initialisation des données pour chaque catégorie
    //                         if (!categoriesData[day.date][categoryName]) {
    //                             categoriesData[day.date][categoryName] = 0;
    //                         }
    //
    //                         // Ajout du chiffre d'affaires
    //                         categoriesData[day.date][categoryName] += productData.totalPrice;
    //                         categories.add(categoryName);
    //                     });
    //                 });
    //             });
    //         });
    //     });
    //
    //     // Préparation des séries de données pour le graphique
    //     const series = [];
    //     const labels = Object.keys(categoriesData);
    //
    //     categories.forEach(category => {
    //         const data = labels.map(label => categoriesData[label][category] || 0);
    //         series.push({
    //             name: category,
    //             data: data
    //         });
    //     });
    //
    //     return {
    //         series: series,
    //         options: {
    //             chart: {
    //                 type: 'bar',
    //                 height: 350
    //             },
    //             xaxis: {
    //                 categories: labels,
    //                 title: {
    //                     text: 'Jours'
    //                 }
    //             },
    //             yaxis: {
    //                 title: {
    //                     text: 'Chiffre d\'affaires (€)'
    //                 }
    //             },
    //             title: {
    //                 text: 'Chiffre d\'affaires par jour et par catégorie'
    //             },
    //             tooltip: {
    //                 y: {
    //                     formatter: (value) => `€${value}`
    //                 }
    //             }
    //         }
    //     };
    // }

    function getApexChartData(sumdays, weatherDays, filter) {
        // Extraction des données pour le treemap
        const seriesData = [];
        const allProducts = getAllProducts(sumdays);

        const categorySales = {};

        allProducts.forEach((product) => {
            const categoryName = product.categoryName || 'Autres'; // Utiliser 'Autres' si pas de catégorie
            if (!categorySales[categoryName]) {
                categorySales[categoryName] = 0;
            }
            categorySales[categoryName] += product.totalPrice;
        });

        // Préparation des données pour le treemap
        Object.keys(categorySales).forEach((categoryName) => {
            seriesData.push({
                x: categoryName,
                y: categorySales[categoryName] // Chiffre d'affaires
            });
        });

        return {
            series: [{
                data: seriesData
            }],
            options: {
                legend: {
                    show: false
                },
                chart: {
                    height: 350,
                    type: 'treemap'
                },
                title: {
                    text: 'Chiffre d\'affaires par catégorie'
                },
                tooltip: {
                    y: {
                        formatter: (value) => `€${value}`
                    }
                }
            }
        };
    }

    // function getApexChartData(sumdays, weatherDays) {
    //     // Extraction des données pour le treeMap
    //     const seriesData = [];
    //
    //     const allProducts = getAllProducts(sumdays);
    //
    //     const productSumup = {};
    //
    //     allProducts.forEach((product) => {
    //         if (!productSumup[product.name]) {
    //             productSumup[product.name] = {};
    //             productSumup[product.name].totalTurnover = product.totalPrice;
    //         }
    //         else {
    //             productSumup[product.name].totalTurnover += product.totalPrice;
    //         }
    //
    //     })
    //
    //     Object.keys(productSumup).forEach((productKey) => {
    //         const productDetails = productSumup[productKey];
    //         seriesData.push({
    //             x: `${productKey}`, // Nom du produit avec le créneau horaire
    //             y: productDetails.totalTurnover // Chiffre d'affaires
    //         });
    //     })
    //
    //
    //     return {
    //         series: [{
    //             data: seriesData
    //         }],
    //         options: {
    //             legend: {
    //                 show: false
    //             },
    //             chart: {
    //                 height: 350,
    //                 type: 'treemap'
    //             },
    //             title: {
    //                 text: 'Chiffre d\'affaires par produit et créneau horaire'
    //             },
    //             tooltip: {
    //                 y: {
    //                     formatter: (value) => `€${value}`
    //                 }
    //             }
    //         }
    //     };
    // }

    function fillNamesOfSumDays(sumUpDays, staffs, locations, products, optionLists, paymentModes, categories) {
        if (!sumUpDays || sumUpDays.length == 0 || !products || !staffs || !paymentModes || !locations || !optionLists || !categories) {
            return [];
        }
        let all = []
        sumUpDays.forEach((sumUpDay) => {
            if (sumUpDay.content) {
                const contentParsed = JSON.parse(sumUpDay.content);
                all.push({
                    ...fillDataNames(contentParsed, staffs, locations, products, optionLists, paymentModes, categories),
                    date: sumUpDay.id
                });
            }
        })


        return all;
        // return fillDataNames(sumUpDays, staffs, locations, products, []);
    }

    useEffect(() => {

            if (!sumUpDaysStructured || !sumUpDays || !products || !staffs || !paymentModes || !locations || !categories ) {
                return;
            }
            try {

                const res = getApexChartData(
                    sumUpDaysStructured, weatherDays, filter
                );

                if (res) {
                    setChartOptions(res);
                }

            } catch (e) {
                console.error('Erreur lors de l’exécution du code dynamique :', e);
            }
        }
        , [sumUpDays, products, staffs, paymentModes, locations, categories, sumUpDaysStructured])

    const [state, setState] = React.useState({

        series: [
            {
                data: [
                    // {
                    //     x: 'New Delhi',
                    //     y: 218
                    // },
                    // {
                    //     x: 'Kolkata',
                    //     y: 149
                    // },
                    // {
                    //     x: 'Mumbai',
                    //     y: 184
                    // },
                    // {
                    //     x: 'Ahmedabad',
                    //     y: 55
                    // },
                    // {
                    //     x: 'Bangaluru',
                    //     y: 84
                    // },
                    // {
                    //     x: 'Pune',
                    //     y: 31
                    // },
                    // {
                    //     x: 'Chennai',
                    //     y: 70
                    // },
                    // {
                    //     x: 'Jaipur',
                    //     y: 30
                    // },
                    // {
                    //     x: 'Surat',
                    //     y: 44
                    // },
                    // {
                    //     x: 'Hyderabad',
                    //     y: 68
                    // },
                    // {
                    //     x: 'Lucknow',
                    //     y: 28
                    // },
                    // {
                    //     x: 'Indore',
                    //     y: 19
                    // },
                    // {
                    //     x: 'Kanpur',
                    //     y: 29
                    // }
                    // {
                    //     x: "COCKTAILS",
                    //     y: 2137
                    // },
                    // {
                    //     x: "PLATS",
                    //     y: 3470
                    // },
                ]
            }
        ],
        options: {
            legend: {
                show: false
            },
            chart: {
                height: 350,
                type: 'treemap'
            },
            title: {
                text: 'Basic Treemap'
            }
        },


    });

    function convertSeries(chartOptions) {
        if (chartOptions?.options?.chart?.type === 'treemap') {
            return (chartOptions.series || []).map((serie) => {

                const data = {
                    name: serie.name,
                    data: (serie.data || []).map((item) => {
                        var keys = Object.keys(item);

                        return {
                            x: item[keys[0]],
                            y: item[keys[1]],
                        }
                    })
                };
                return data
            });
        }
        return null;
    }

    return (
        <Card>
            <CardContent>
                 {chartOptions &&
                    <>
                        {sumUpDaysStructured && sumUpDaysStructured.length > 0 && chartOptions  &&
                            <ApexChart
                                options={chartOptions.options}
                                series={chartOptions.series}
                                type={chartOptions.options?.chart?.type}
                                height={350}
                            />
                        }
                    </>
                }
            </CardContent>
        </Card>
    )

    //getApexChartData
}

export default Index